import { AdminApi } from 'stylemix-vue-admin'

export default class OrdersApi extends AdminApi {
  constructor(parameters) {
    super('orders', parameters)
  }

  notification(order, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/${order.id}/notification`,
      null,
      config,
    )
  }

  cancel(order, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/${order.id}/cancel`,
      null,
      config,
    )
  }

  requestRefund(order, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/${order.id}/request-refund`,
      null,
      config,
    )
  }

  refund(order, data = {}, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/${order.id}/refund`,
      data,
      config,
    )
  }

  complete(order, data = {}, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/${order.id}/complete`,
      data,
      config,
    )
  }
}
